export default "__VITE_ASSET__2fa62902__"